import { render, staticRenderFns } from "./index.vue?vue&type=template&id=94b7f598&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94b7f598')) {
      api.createRecord('94b7f598', component.options)
    } else {
      api.reload('94b7f598', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=94b7f598&", function () {
      api.rerender('94b7f598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/UserSettings/UserSettingsContact/index.vue"
export default component.exports